import React, { useState } from "react";
import { connect, useDispatch } from "react-redux";
import { createStructuredSelector } from "reselect";
import PropTypes from "prop-types";

import CustomTabButton from "../CustomTabButton";
import FilterByLeagues from "../FilterByLeagues";
import FilterByLocation from "../FilterByLocation";
import "./searchForm.scss";
import { selectWidth } from "../../redux/screenDimensions/screenDimensionsSelectors";
import Ad from "../Ad/Ad";
import {
  fetchSelectedLeague,
  fetchSelectedStadium,
  fetchSelectedTeam,
} from "../../redux/leagues/leaguesActions";
import { fetchFormValues } from "../../redux/formValues/formValuesActions";
import Mixpanel from "../../utils/mixPanel";
import UnlockFeatureModal from "../UnlockFeatureModal";
const platform = typeof window !== "undefined" ? "web" : "mobile";
const SearchForm = ({ width }) => {
  const [index, setIndex] = useState(() =>
    window.location.href.includes("searchByLeagues") ||
    window.location.href.includes("leagueId")
      ? 1
      : 0
  );

  const dispatch = useDispatch();
  const [shouldApplyMargin, setShouldApplyMargin] = useState(false);
   const handleMarginChange = (searchBtns) => {
    setShouldApplyMargin(searchBtns === 2 || searchBtns === 3);
  };
  return (
    <div className={`search-form-container`}>
      {/* <button onClick={() => setUnlockFeatureModal(true)}>dssdsd</button> */}
      {/* <div className="tab-buttons">
        <CustomTabButton
          text="Search By Location"
          selected={index === 0 ? true : false}
          callback={() => {
            Mixpanel.track("Pressed search by location", {
              platform: platform,
              application_type: platform === "web" ? "web app" : "mobile app",
            });
            setIndex(0);
            dispatch(fetchSelectedLeague([]));
            dispatch(fetchSelectedStadium([]));
            dispatch(fetchSelectedTeam([]));
            dispatch(
              fetchFormValues({
                leagueSearch: "",
              })
            );
          }}
        />
        <CustomTabButton
          text="Advanced search"
          selected={index === 1 ? true : false}
          callback={() => {
            Mixpanel.track("Pressed advanced search", {
              platform: platform,
              application_type: platform === "web" ? "web app" : "mobile app",
            });
            setIndex(1);
          }}
        />
      </div> */}
      <div>
        {/* {!index ? (
          <FilterByLocation setIndex={setIndex} />
        ) : (
          <FilterByLeagues />
        )} */}
        <FilterByLeagues onSearchBtnChange={handleMarginChange}/>
        {/* {index === 0 && width > 1000 ? ( */}
        {/* {index === 0 ? (
          <div style={{
            marginTop: shouldApplyMargin ? 60 : 10, 
          }}>
            <Ad slot="7944567579" styles={{ width: 390, height: 150 }} />
          </div>
        ) : null} */}
      </div>
      {/* <UnlockFeatureModal unlockFeatureModal={unlockFeatureModal} setUnlockFeatureModal={setUnlockFeatureModal} /> */}
    </div>
  );
};

const mapStateToProps = createStructuredSelector({
  width: selectWidth,
});

SearchForm.propTypes = {
  width: PropTypes.number,
};

export default connect(mapStateToProps)(SearchForm);
